import { render, staticRenderFns } from "./HeaderView.vue?vue&type=template&id=a5b613c0&scoped=true&lang=pug&"
import script from "./HeaderView.vue?vue&type=script&lang=js&"
export * from "./HeaderView.vue?vue&type=script&lang=js&"
import style0 from "./HeaderView.vue?vue&type=style&index=0&id=a5b613c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b613c0",
  null
  
)

/* custom blocks */
import block0 from "./HeaderView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports